<template>
  <b-row align-v="center" class="mb-4">
    <b-col lg="auto" md="1" sm="1" cols="1">
      <img :src="imgSrc" />
    </b-col>
    <b-col class="pl-4">
      <slot></slot>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "DeleteAccountStepOneContentList",
  props: {
    imgSrc: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped></style>
